import { Award, Building2 } from "lucide-react";

const REFS = [
    {
        name: "Grupo Vidanta",
        desc: "Cubrimos lobby y canchas de su resort en Riviera Maya",
    },
    {
        name: "Aeropuerto de Guadalajara",
        desc: "Velarias en accesos terminales",
    },
    {
        name: "Metro CDMX",
        desc: "Cubiertas en estaciones y áreas operativas",
    },
    {
        name: "Cadena hotelera nacional",
        desc: "Terrazas premium en 5 propiedades",
    },
];

export default function ReferenceClients() {
    return (
        <section
            data-testid="reference-clients"
            className="relative bg-eclipse-primary py-20 sm:py-28 overflow-hidden"
        >
            {/* Badge IFAI */}
            <div className="absolute top-6 right-6 sm:top-10 sm:right-10 z-10">
                <div
                    data-testid="ifai-badge"
                    className="inline-flex items-center gap-2 bg-eclipse-cta text-white px-4 py-2 rounded-sm shadow-lg"
                >
                    <Award className="w-4 h-4" strokeWidth={2.25} />
                    <span className="font-display font-bold text-xs tracking-[0.15em] uppercase">
                        Premio IFAI 2021
                    </span>
                </div>
            </div>

            <div className="container-eclipse">
                <div className="max-w-3xl mb-14">
                    <p className="font-display font-bold text-xs tracking-[0.3em] text-eclipse-cta mb-3">
                        CONFIANZA
                    </p>
                    <h2 className="font-display font-black text-3xl sm:text-4xl lg:text-5xl text-white tracking-tight leading-tight">
                        Confían en Eclipse Cubiertas
                    </h2>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                    {REFS.map((r) => (
                        <div
                            key={r.name}
                            data-testid={`reference-${r.name.toLowerCase().replace(/\s/g, "-")}`}
                            className="bg-white/[0.04] border border-white/10 hover:border-eclipse-cta/60 p-6 sm:p-7 rounded-sm flex items-start gap-4 transition-colors"
                        >
                            <div className="w-11 h-11 rounded-sm bg-eclipse-cta/15 border border-eclipse-cta/30 flex items-center justify-center flex-shrink-0">
                                <Building2 className="w-5 h-5 text-eclipse-cta" />
                            </div>
                            <div>
                                <h3 className="font-display font-bold text-white text-lg leading-tight mb-1.5">
                                    {r.name}
                                </h3>
                                <p className="text-sm text-white/65 leading-relaxed">
                                    {r.desc}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
